<template>
  <div class="pretraining-intro">
    <div>
      <h2 class="mb-4 pretraining-intro-heading">{{ video.title }}</h2>
      <p class="pretraining-intro-summary">{{ video.summary }}</p>
    </div>
    <div class="pretraining-intro-main">
      <Video
        :thumbnail="video.thumbnail"
        :video="video.code"
        :completed="completed"
        :currentTime="currentTime"
        :isIntroPassed="passed"
        :isIntro="true"
        @pauseVideo="onPauseVideo"
        @endVideo="onEndVideo"
        @resetVideo="onResetVideo"
        @checkCompletion="checkCompletion"
      />
      <div class="pretraining-intro-topics">
        <h3 class="pretraining-intro-topics-heading">{{ $t('preTraining.intro.listHeading') }}</h3>
        <ul>
          <li v-for="(topic, index) in topics" :key="topic" class="pretraining-intro-topics-topic">
            <span class="pretraining-intro-topics-topic-dot" />
            <span class="text-md">
              {{ `${$t('preTraining.intro.listPrefix', { number: index + 1 })}  ${topic}` }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <button
      class="button rounded-full py-5 mx-auto my-10"
      :disabled="!completed && !passed"
      @click="$emit('next')"
    >
      {{ !completed && !passed ? $t('preTraining.startBtn') : $t('preTraining.continueBtn') }}
    </button>
  </div>
</template>

<script>
import Video from './Video';

export default {
  name: 'PretrainingIntroVideo',
  components: { Video },
  props: {
    video: Object,
    topics: Array,
    passed: Boolean,
    onPauseVideo: Function,
    onEndVideo: Function,
    onResetVideo: Function,
  },
  data() {
    return {
      completed: false,
    };
  },
  computed: {
    currentTime() {
      return this.video && this.video.progress ? this.video.progress.time : '0';
    },
  },
  methods: {
    checkCompletion(currentTime, duration) {
      this.completed = currentTime === duration;
    },
  },
};
</script>
